import { useEffect, useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api, post } from '../api.js';
import type { WorkspaceSummary } from '../types.js';
import { useI18n } from '../i18n.js';

export function WorkspacesPage() {
  const { t } = useI18n();
  const [workspaces, setWorkspaces] = useState<WorkspaceSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const load = async () => {
    setLoading(true);
    try {
      const result = await api<{ workspaces: WorkspaceSummary[] }>('/workspaces');
      setWorkspaces(result.workspaces);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Failed to load workspaces');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { void load(); }, []);
  const create = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const name = new FormData(form).get('name');
    try {
      await post('/workspaces', { name });
      form.reset();
      await load();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Failed to create workspace');
    }
  };
  return (
    <div className="content-width">
      <div className="page-heading">
        <div><span className="eyebrow">Control plane</span><h1>{t('workspaces')}</h1><p>Один workspace объединяет репозитории, харнессы, работы и решения команды.</p></div>
        <form className="inline-form" onSubmit={(event) => void create(event)}>
          <label className="sr-only" htmlFor="workspace-name">Название workspace</label>
          <input id="workspace-name" name="name" placeholder="Новый workspace" required maxLength={200} />
          <button className="button primary">{t('create')}</button>
        </form>
      </div>
      {error && <p className="error-box" role="alert">{error}</p>}
      {loading ? <div className="skeleton-grid" /> : workspaces.length === 0 ? (
        <div className="panel empty-state"><h2>Создайте первое пространство</h2><p>Затем добавьте репозиторий и получите одноразовый код подключения харнесса.</p></div>
      ) : (
        <div className="workspace-grid">
          {workspaces.map((workspace) => (
            <Link className="workspace-card" to={`/workspaces/${workspace.id}`} key={workspace.id}>
              <span className="workspace-icon">{workspace.name.slice(0, 2).toUpperCase()}</span>
              <div><h2>{workspace.name}</h2><p>Policy v{workspace.policy_version} · {workspace.role ?? 'owner'}</p></div>
              <span className="arrow">→</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
